var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PC-Web:-OceanReady----Medallion",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9.7.b.1--Modify-Medallion-Modify-Medallion-9.7.b.1-Modify-Medallion",
    transform: "translate(-680.000000, -153.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "saving",
    transform: "translate(670.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(11.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2520867,0.696947368 C9.39214861,0.343263158 8.45017957,0.147868421 7.4618452,0.147868421 C3.42291022,0.147868421 0.148804954,3.40957895 0.148804954,7.43273684 C0.148804954,11.4558947 3.42291022,14.7176053 7.4618452,14.7176053 C11.5007802,14.7176053 14.7752817,11.4558947 14.7752817,7.43273684",
    id: "Stroke-1",
    stroke: "#FFFFFF",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1111232,2.46509211 C13.1111232,2.62851316 12.9779715,2.76114474 12.8139096,2.76114474 C12.6498477,2.76114474 12.516696,2.62851316 12.516696,2.46509211 C12.516696,2.30167105 12.6498477,2.16903947 12.8139096,2.16903947 C12.9779715,2.16903947 13.1111232,2.30167105 13.1111232,2.46509211",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2005895,3.84611842 C14.2005895,4.00953947 14.0674378,4.14217105 13.9033759,4.14217105 C13.7393139,4.14217105 13.6061622,4.00953947 13.6061622,3.84611842 C13.6061622,3.68269737 13.7393139,3.55006579 13.9033759,3.55006579 C14.0674378,3.55006579 14.2005895,3.68269737 14.2005895,3.84611842",
    id: "Fill-5",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7950167,5.53334211 C14.7950167,5.69676316 14.661865,5.82939474 14.4978031,5.82939474 C14.3337412,5.82939474 14.2005895,5.69676316 14.2005895,5.53334211 C14.2005895,5.36992105 14.3337412,5.23728947 14.4978031,5.23728947 C14.661865,5.23728947 14.7950167,5.36992105 14.7950167,5.53334211",
    id: "Fill-7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8829176,1.44884211 C11.8829176,1.61226316 11.7497659,1.74489474 11.585704,1.74489474 C11.4216421,1.74489474 11.2884904,1.61226316 11.2884904,1.44884211 C11.2884904,1.28542105 11.4216421,1.15278947 11.585704,1.15278947 C11.7497659,1.15278947 11.8829176,1.28542105 11.8829176,1.44884211",
    id: "Fill-9",
    fill: "#FFFFFF"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.f5e91e5c4d118ed5bc3ee534342af407.svg";
export { ForwardRef as ReactComponent };